import React from 'react';
import PropTypes from 'prop-types';
import View from 'components/view';
import Icon from 'components/icon';
import ButtonLink from 'components/button/link';
import Confetti from 'components/loading/confetti';
import LoadingAsyncTask from 'components/loading/async-task';
import { getStorefrontURL } from 'utils/storefront';

import createdLaptopBg from './created-laptop-bg.svg';

import './storefront.scss';

export default class StorefrontCreated extends React.PureComponent {
  static propTypes = {
    app: PropTypes.object,
    storefront: PropTypes.object.isRequired,
  };

  state = {
    record: null,
    isProgressing: null,
  };

  componentDidMount() {
    const { storefront } = this.props;

    if (!storefront) {
      router.replace('/storefronts/new');
    }

    this.setState({
      record: storefront,
      isProgressing: Boolean(storefront?.async_progressing),
    });
  }

  onProgressing = (record, progressing) => {
    this.setState({ record, isProgressing: progressing });
  };

  onCompleted = (record) => {
    const { router } = this.props;
    router.replace(`/storefronts/created/${record.id}`);
  };

  render() {
    const { app } = this.props;
    const { record: storefront, isProgressing } = this.state;

    if (storefront === null) {
      return null;
    }

    const canEditTheme = Boolean(storefront?.theme);

    const previewImage = app.preview_image;
    const previewThumbnails = app.preview_theme?.preview_thumbnails;

    const previewImageUrl = previewImage?.url
      ? `${previewImage.url}?width=1200&anchor=top`
      : previewThumbnails?.desktop;

    return (
      <>
        {!isProgressing && <Confetti />}
        <View
          detail={true}
          backTitle="Back to dashboard"
          backUrl="/storefronts"
          className="storefront-new-created"
        >
          <div className="storefront-created-container">
            <div className="storefront-created-image">
              <img
                src={createdLaptopBg}
                className="storefront-created-laptop-bg"
              />
              <div className="storefront-created-laptop-screen">
                {isProgressing ? (
                  <LoadingAsyncTask
                    record={storefront}
                    onCompleted={this.onCompleted}
                    onProgressing={this.onProgressing}
                    endpoint="storefronts"
                    tasks={[{ type: 'install', label: 'Installing files' }]}
                    size={30}
                  />
                ) : previewThumbnails?.loading ? (
                  <div className="loading-async-task">
                    <Loading size={30} />
                    Generating preview
                  </div>
                ) : previewImageUrl ? (
                  <img src={previewImageUrl} alt={storefront.name} />
                ) : (
                  <Icon fa="laptop-code" faType="light" />
                )}
              </div>
            </div>
            <div className="storefront-created-content">
              <div className="storefront-created-title">
                {isProgressing
                  ? 'Your storefront is being created'
                  : 'Your storefront is ready'}
              </div>
              <div className="storefront-created-subtitle">
                {isProgressing
                  ? 'This may take a few minutes.'
                  : `Continue to preview and customize your ${
                      canEditTheme ? 'theme' : 'settings'
                    }.`}
              </div>
              <div className="storefront-created-actions">
                {isProgressing ? (
                  <ButtonLink to={`/storefronts`} size="md" type="secondary">
                    Back to dashboard
                  </ButtonLink>
                ) : (
                  <>
                    {canEditTheme ? (
                      <ButtonLink
                        to={`/storefronts/${storefront.id}/editor`}
                        size="md"
                      >
                        Edit theme
                      </ButtonLink>
                    ) : (
                      <ButtonLink
                        to={`/storefronts/${storefront.id}`}
                        type="secondary"
                        size="md"
                      >
                        Edit settings
                      </ButtonLink>
                    )}
                    <ButtonLink
                      href={getStorefrontURL(storefront, true)}
                      type="secondary"
                      size="md"
                    >
                      Preview store
                    </ButtonLink>
                  </>
                )}
              </div>
            </div>
          </div>
        </View>
      </>
    );
  }
}
